import { Model } from "vuex-fetch-factory";

export enum AddressType {
  business = "business",
  post = "post",
  invoice = "invoice",
  delivery = "delivery"
}

export interface AddressRaw {
  relation_id: number;
  type: AddressType;
  internal_line: string;
  internal_line2: string;
  street: string;
  house_number: number;
  house_number_suffix: string;
  town: string;
  postal_code: string;
  country: string;
}

export class AddressModel implements Model<AddressModel, AddressRaw> {
  public relation_id = 0;
  public type: AddressType = AddressType.business;
  public internal_line = "";
  public internal_line2 = "";
  public street = "";
  public house_number = 0;
  public house_number_suffix = "";
  public town = "";
  public postal_code = "";
  public country = "";

  public getNew(): AddressModel {
    return new AddressModel();
  }

  public fillModel(raw: AddressRaw): this {
    this.relation_id = raw.relation_id;
    this.type = raw.type;
    this.internal_line = raw.internal_line;
    this.internal_line2 = raw.internal_line2;
    this.street = raw.street;
    this.house_number = raw.house_number;
    this.house_number_suffix = raw.house_number_suffix;
    this.town = raw.town;
    this.postal_code = raw.postal_code;
    this.country = raw.country;
    return this;
  }

  public getRaw(): AddressRaw {
    return {
      relation_id: this.relation_id,
      type: this.type,
      internal_line: this.internal_line,
      internal_line2: this.internal_line2,
      street: this.street,
      house_number: this.house_number,
      house_number_suffix: this.house_number_suffix,
      town: this.town,
      postal_code: this.postal_code,
      country: this.country
    };
  }
}
